import React from 'react';
import './Navbar.css';
 import BarChartIcon from '@mui/icons-material/BarChart';

const Navbar = React.memo(() => {
  return (
    <header className="navbar-header" role="banner">
      <div className="navbar-left">
        <div className="navbar-icon" aria-label="Dashboard Icon" role="img"><BarChartIcon></BarChartIcon></div> 
        <h1 className="navbar-title">Analytics Dashboard</h1>
      </div>

      <div className="navbar-right">
        {/* Add right-side buttons or user controls here */}
      </div>
    </header>
  );
});

export default Navbar;
